import { GetterTree } from 'vuex';
import { IState } from './state';
import { IStore } from '@store/index';
import Appointment from "./interfaces/appointment";
import { format } from "@lib/formatter/currency";
import { DateTime } from "luxon";
import { formatToLocaleString } from "@lib/common/date/dateFormatter";
import { UpdateAppointmentStatus } from "@store/dateAndPrice/interfaces/updatedAppointment";

export default {
    sanitizedAirports (state) {
        return state.dateAndPriceData.airports.filter(airport => airport.name !== '' && airport.minPrice)
    },
    hasNotes: () => (appointment: Appointment) => {
        return appointment.priceNote !== '' || appointment.discountDescription !== '';
    },
    isFetching (state) {
        return state.isFetching;
    },
    hasAvailabilityInformation: () => (appointment: Appointment) => {
        return appointment.availability !== null && Object.keys(appointment.availability ?? {}).length > 0 && appointment.availability?.status !== 'None';
    },
    dateFrom: () => (appointment: Appointment, locale: string) => {
        return formatToLocaleString(appointment.dateFrom, locale, DateTime.DATE_SHORT);
    },
    dateTo: () => (appointment: Appointment, locale: string) => {
        return formatToLocaleString(appointment.dateTo, locale, DateTime.DATE_SHORT);
    },
    formattedPrice: () => (appointment: Appointment, locale: string = 'de-DE') => {
        return format(appointment.price, appointment.currency, locale, {
            style: 'decimal',
            fraction: 0,
            spaceBetween: true,
        })
    },
    updateAppointmentIsNotSuccessful (state) {
        return state.updatedAppointment !== undefined &&
            (state.updatedAppointment?.priceChanged || Math.round(state.updatedAppointment?.priceDifference) !== 0
                || state.updatedAppointment?.status === UpdateAppointmentStatus.SOLDOUT
                || state.updatedAppointment?.status === UpdateAppointmentStatus.ERROR
                || state.updatedAppointment?.status === UpdateAppointmentStatus.AIRPORT_SOLDOUT
            );
    }
} as GetterTree<IState, IStore>
